import { ensureArray } from "../common/utils/arrayUtilities";

export const checkEnabled = (clientConfig, flag, entity) => {
    if (!flag || flag === 'false') {
        return false;
    }
    if (flag === true || flag === 'true') {
        return true;
    }

    if (!entity) {
        return !!flag;
    }

    if (Array.isArray(flag)) {
        const matches = a => (!clientConfig.enableSites || !entity?.site || !a?.site || a.site === entity.site) && (!clientConfig.enableLevels || !entity?.level || !a?.level || a.level === entity.level);
        if (!flag.some(matches)) {
            return false;
        }
        return true;
    }
    return !!flag
}

export const checkEnabledValue = (clientConfig, flag, values, entity) => {
    if (!flag || flag === 'false') {
        return false;
    }
    const valueList = ensureArray(values);

    if (typeof flag === 'string') {
        return valueList.includes(flag);
    }

    const entries = ensureArray(flag);

    if (entity && (entity.site || entity.level)) {
        const strictSiteAndLevelMatch = entries.some((e) => clientConfig.enableSites && clientConfig.enableLevels && e.site === entity.site && e.level === entity.level && valueList.includes(e.value));

        const permissiveSiteMatch = entries.some((e) => (!clientConfig.enableSites || !entity?.site || !e?.site || e.site === entity.site) && valueList.includes(e.value));

        const permissiveLevelMatch = entries.some((e) => (!clientConfig.enableLevels || !entity?.level || !e?.level || e.level === entity.level) && valueList.includes(e.value));

        return strictSiteAndLevelMatch || (permissiveSiteMatch && permissiveLevelMatch);
    }

    return entries.some((e) => valueList.includes(e.value));
}